import { ChallengeCard } from "../challenge/ChallengeView.interface";


interface ChapterView {
  id:string;
  url:string;
  coverImgUrl: string;
  introImgUrl:string;
  title: string;
  index: string;
  description: string;
  tags: Array<string>;
  challenges: Array<ChallengeCard>;
}

const defaultChapterView  = new Map<string, ChapterView>();

export { ChapterView, defaultChapterView };
